<template>
<div class="chapter">
<div class="inner_page">
<div class="copyrightPage" id="cop01">
<a id="pagevi">
<p class="copyrightText"><img alt="image" src="Images/crlogo1.jpg"/><br/>A Division of Simon &amp; Schuster, Inc.<br/> 1230 Avenue of the Americas<br/> New York, NY 10020</p>
</a><p class="copyrightText"><a id="pagevi"><img alt="image" src="Images/crlogo2.jpg"/><br/>20827 N.W. Cornell Road, Suite 500<br/> Hillsboro, Oregon 97124-9808<br/> 503-531-8700 / 503-531-8773<br/> fax <span class="xrefURL"></span></a><a href="http://www.beyondword.com" target="_blank">www.beyondword.com</a></p>
<p class="copyrightText">Copyright © 2005, 2008 by Mike Dooley</p>
<p class="copyrightText">All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever without the prior written permission of Atria Books/Beyond Words Publishing, Inc., except where permitted by law.</p>
<p class="copyrightText"><span class="bold"><span class="smallCaps">ATRIA</span></span> <span class="smallCaps">BOOKS</span> and colophon are trademarks of Simon &amp; Schuster, Inc.</p>
<p class="copyrightText">Beyond Words Publishing is a division of Simon &amp; Schuster, Inc.</p>
<p class="copyrightText">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyrightText">Dooley, Mike.</p>
<p class="copyrightText">Even more notes from the universe: dancing life’s dance / Mike Dooley.<br/> p. cm.<br/> 1. Self-help techniques—Miscellanea. 2. Spirituality—Miscellanea. 3. Occultism—Miscellanea. I. Title.<br/> BF1999.D61551      2008<br/> 158—dc22           2008017876</p>
<p class="copyrightText">ISBN-13: 978-1-4165-9416-1<br/>ISBN-10: 1-4165-9416-7</p>
<p class="copyrightText">The corporate mission of Beyond Words Publishing, Inc.: <em class="italic">Inspire to Integrity</em></p>
<p class="copyrightText">Visit us on the World Wide Web: <br/><span class="xrefURL"><a href="http://www.SimonSays.com" target="_blank">http://www.SimonSays.com</a></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416594161_cop01.vue?5c376814